import { Component, Input, Output, OnDestroy, OnInit, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from '../../constants/app-constants';
import { DataService } from '../../services/data.service';
import { UserCacheService } from '../../services/user-cache.service';
import { SaeResetPasswordService } from './sae-reset-password.service';
import { FwcPreloader } from '../../../../fwc-lib.js';
import { Subscription } from 'rxjs';

@Component({
    selector: 'sae-reset-password',
    templateUrl: './sae-reset-password.component.html',
    styleUrls: ['./sae-reset-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SaeResetPasswordComponent implements OnInit, OnDestroy {

  token: any;
  routerObs: Subscription;
  resetPasswordObs: Subscription
  constructor(
    private formBuilder: UntypedFormBuilder,
    public router: Router,
    private saeResetPasswordService: SaeResetPasswordService,
    private userCacheService: UserCacheService,
    private route: ActivatedRoute,
    private dataService: DataService
) { 
  this.routerObs = route.queryParams.subscribe(param => {
    this.token = param.token;
  })
   const fwcPreloader = new FwcPreloader();
   fwcPreloader.build();
}

@Input() content: any;
@Input() userId: any;
@Output() resetSuccess = new EventEmitter<boolean>();
resetPasswordForm!: UntypedFormGroup;
submitted = false;
masked = true;
createMask = true;
retypeMask = true;
showPasswordRules = false;
ruleLowerMet = false;
rule8characterMet = false;
ruleUpperMet = false;
ruleSpecialMet = false;
ruleNumberMet = false;
ruleUpperCharMet = false;
passwordValidateError = false;
passwordMatchError = false;
displaySpinner = false;
isResetPasswordSuccess = false;
 expiryTime = 10; // 10 seconds
  oneTimeCode = '';
  remainingTime = 10;
  timerInterval: any;

public dispalyContent = {
  response: {
      passwordContainsUsername: 'Your new password cannot contain 3 or more characters of your associated username.',
      validationFalied: 'Password does not match all requirements',
      exception: 'exception occur',
      success:'Your password has been updated!',
      linkExpired: 'This reset link has expired. Kindly request for a new password recovery link.',
      unknown: 'something went wrong, Please try again'
  }
};

ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group({
        gibberish: ['', Validators.required],
        retypePassword: ['', Validators.required],
    });
   // this.checkInvalidToken();
}

ngOnDestroy() {
  if (this.routerObs){
    this.routerObs.unsubscribe();
  }
  if(this.resetPasswordObs) {
    this.resetPasswordObs.unsubscribe();
  }
}
 startTimer(): void {
    this.stopTimer();
    this.timerInterval = setInterval(() => {
      this.remainingTime--;
      if (this.remainingTime <= 0) {
        this.stopTimer();
      }
    }, 1000);
  }
  stopTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
      // Navigate to login when timer expires
      if (this.remainingTime <= 0) {
        this.navigateTo('/login');
      }
    }
  }
checkInvalidToken () {
  this.saeResetPasswordService.resetPassword(this.token, '').subscribe(data => {
    const response: any = data;
    if(response.token === '' && response.status === AppConstants.FAILURE_STATUS) {
      this.navigateTo('/login');
      this.dataService.doAnnouncement({topic: AppConstants.RESET_PD_FAILED, message: 'This reset link has expired. Click on forgot your password below to request a new password recovery link.'});
    }
  }, err => {
    console.log('error occured ', err);
  });
}
get form(): { [p: string]: AbstractControl } { return this.resetPasswordForm.controls; }

onSubmit(): void {
    this.submitted = true;
    if (this.resetPasswordForm.valid && !this.passwordValidateError && !this.passwordMatchError) {
      const { gibberish } = this.resetPasswordForm.value;
      this.displaySpinner = true;
      this.dataService.doAnnouncement(null);
      this.resetPasswordObs = this.saeResetPasswordService.resetOktaPassword(this.userId, gibberish).subscribe((data:any) =>{
        this.displaySpinner =false;
        if (data.status === AppConstants.SUCCESS) {
          this.isResetPasswordSuccess=true;
          this.resetSuccess.emit(true);
          this.remainingTime = this.expiryTime;
          this.startTimer();
          //this.navigateTo('/login')
          this.dataService.doAnnouncement({topic: AppConstants.FORGOT_PD_SUCCESS, message: this.dispalyContent.response.success});
        } else if (data.status === AppConstants.FAILURE_STATUS) {
          this.navigateTo('/login')
          this.dataService.doAnnouncement({topic: AppConstants.FORGOT_PD_FAILED, message: this.dispalyContent.response.exception});
        //  } else if (data.errorMessage === 'USER_ERR_001') {
        //   this.dataService.doAnnouncement({topic: AppConstants.FORGOT_PD_FAILED, message: this.dispalyContent.response.validationFalied});
        //  } else if (data.errorMessage === 'USER_ERR_102') {
        //   this.dataService.doAnnouncement({topic: AppConstants.FORGOT_PD_FAILED, message: this.dispalyContent.response.exception});
         } 
      }, err => {
        this.displaySpinner =false;
        console.log(err)
        this.dataService.doAnnouncement({topic: AppConstants.FORGOT_PD_FAILED, message: this.dispalyContent.response.unknown});
      })

    }
}

navigateTo(path): void {
    this.router.navigate([path], { replaceUrl: true });
}

validateFields(): boolean {
    let returnVal = true;
    this.passwordMatchError = false;
    this.passwordValidateError = false;
    if (!this.passwordMatch(this.form.gibberish.value, this.form.retypePassword.value)) {
      this.passwordMatchError = true;
      returnVal = false;
    } 
    if (!this.passwordValidation(this.form.gibberish.value)) {
      this.passwordValidateError = true;
      returnVal = false;
    } 
    return returnVal;
  }
  checkPasswordRules(): void {
    // pass input value here and check against password rules
    this.showPasswordRules = true;
    this.ruleLowerMet = false;
    this.rule8characterMet = false;
    this.ruleUpperMet = false;
    this.ruleSpecialMet = false;
    this.ruleNumberMet = false;
    this.ruleUpperCharMet = false;
    if (/[0-9]/g.test(this.form.gibberish.value)) {
      this.ruleNumberMet = true;
    }
    if (/[a-z]/g.test(this.form.gibberish.value)) {
      this.ruleLowerMet = true;
    }
    if (/[A-Z]/g.test(this.form.gibberish.value)) {
      this.ruleUpperMet = true;
    }
    if (/[$!@*?|]/g.test(this.form.gibberish.value)) {
      this.ruleSpecialMet = true;
    }
    if (/.{12,}/.test(this.form.gibberish.value)) {
      this.rule8characterMet = true;
    }
    if (/[A-Z]/g.test(this.form.gibberish.value)) {
      this.ruleUpperCharMet = true;
    }
  }
  onKey(e): void {
    const regxStr = new RegExp('^[0-9a-zA-Z$!@*?|]*$');
    if (!regxStr.test(e.key)) {
      e.preventDefault();
    }
  }
  passwordMatch(Password: any, retypePassword: any): boolean {
    if (Password != null && retypePassword != null && Password === retypePassword) { return true; }
    else { return false; }
  }
  passwordValidation(password): boolean {
    const generalRules = (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$!@*?|])[A-Za-z\d$!@*?|]{12,20}$/);
    const validateNoSpace = /^\S*$/;
    if (generalRules.test(password) && validateNoSpace.test(password) && this.validateRepeatedCharacter(password)) {
      return true;
    } else {
      return false;
    }
 }
 validateRepeatedCharacter(password): boolean {
    const str: string = password;
    if (str != null) {
      const len: number = str.length;
      const newstr: Array<string> = [];
      for (let i = 0; i < len; i++) {
        newstr[i] = str.charAt(i);
      }
      for (let j = 0; j < len; j++) {
        if ((newstr[j] === newstr[j + 1]) && (newstr[j + 1] === newstr[j + 2])) {
          return false;
        }
      }
    }
    return true;
  }
}
